var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"baiduMap",attrs:{"id":"baiduMap"}}),_c('z-locus'),_c('z-details-drawer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }